"use client";

import {
  BadgeCheck,
  ChevronsUpDown,
  Moon,
  Sun,
  CreditCard,
  LogOut,
  Sparkles,
  UserPlus,
  Mail,
  MessageSquare,
  PlusCircle,
  LaptopMinimal,
  SunMoon,
  Menu,
  Home,
  LayoutGrid,
  TrendingUp,
  HammerIcon,
  CirclePlus,
} from "lucide-react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme } from "next-themes";
import { ModeToggle } from "./mode-toggle";
import { signOut } from "@/lib/auth-client";
import { Button } from "./ui/button";
import Link from "next/link";
import { useIsMobile } from "@/hooks/use-is-mobile";

const navItems = [
  {
    title: "Home",
    url: "/",
    icon: Home,
    isActive: true,
  },
  {
    title: "Browse",
    url: "/browse",
    icon: LayoutGrid,
  },
  {
    title: "Create",
    url: "/create",
    icon: CirclePlus,
  },
];

export function NavDropdown({ heroStyle = false }: { heroStyle?: boolean }) {
  const isMobile = useIsMobile();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="block lg:hidden" asChild>
        <Button
          size="icon"
          className={
            heroStyle
              ? "size-10 aspect-square inline-flex items-center justify-center rounded-full p-0 border border-white/35 bg-black/55 backdrop-blur-md text-white hover:bg-black/70 hover:text-white"
              : "size-10 aspect-square inline-flex items-center justify-center rounded-full p-0"
          }
          variant={heroStyle ? "ghost" : "outline"}
        >
          <Menu className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
        side={isMobile ? "bottom" : "right"}
        align="end"
        sideOffset={8}
      >
        {navItems.map((item) => (
          <Link href={item.url} key={item.title}>
            <DropdownMenuItem>
              {item.icon && <item.icon />}
              {item.title}
            </DropdownMenuItem>
          </Link>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
